import { Pipe, PipeTransform } from '@angular/core';
import { IDetailedWarning } from "libraries/service/resources/booking/interfaces/IGetBookings";

@Pipe({
    name: 'getChangedPriceWarning'
})

export class GetChangedPriceWarningPipe implements PipeTransform {
    public transform(detailedWarningArray: IDetailedWarning[]): IDetailedWarning {
        if (detailedWarningArray?.length) {
            return detailedWarningArray
                .find((detailedWarning: IDetailedWarning): boolean => {
                    return detailedWarning.wCode === "WRN_PRICE_HAS_CHANGED"
                        || detailedWarning.code === "WRN_PRICE_HAS_CHANGED"
                    ;
                });
        }

        return null;
    }
}
